import React, { useEffect, useState } from "react";

import Sidebar from "./components/Sidebar";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";

import axios from "axios";
import { getSearchedSongs } from "./api";
import Player from "./components/Player";

function App() {
  const [oldBollywoodSongs, setOldBollywoodSongs] = useState();
  const [newBollywoodSongs, setNewBollywoodSongs] = useState();
  const [hollywoodSongs, setHollywoodSongs] = useState();
  const [songs, setSongs] = useState();
  const [playingSong, setPlayingSong] = useState([]);
  const [playingTitle, setPlayingTitle] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    getOldBollywoodSongs();
    getNewBollywoodSongs();
    getHollywoodSongs();
  }, []);

  const getOldBollywoodSongs = async () => {
    let songs = await getSearchedSongs("tseries+bollywood+90s+songs");
    let result = [];
    await songs?.map((song) => {
      result.push({
        id: song.id,
        title: song.title,
        cover: song.thumbnails.high.url,
      });
    });
    setOldBollywoodSongs(result);
  };
  const getNewBollywoodSongs = async () => {
    let songs = await getSearchedSongs("tseries+trending+bollywood+songs").then(
      (res) => {
        setPlayingTitle("Bollywood trending");
        return res;
      }
    );
    let result = [];
    await songs?.map((song) => {
      result.push({
        id: song.id,
        title: song.title,
        cover: song.thumbnails.high.url,
      });
    });
    setNewBollywoodSongs(result);
    setSongs(result);
  };
  const getHollywoodSongs = async () => {
    let songs = await getSearchedSongs("hollywood+songs");
    let result = [];
    await songs?.map((song) => {
      result.push({
        id: song.id,
        title: song.title,
        cover: song.thumbnails.high.url,
      });
    });
    setHollywoodSongs(result);
  };

  // "Bollywood trending","90s Bollywood" ,"Hollywood"

  const playSong = async (songId, title) => {
    setError();
    setPlayingSong([]);
    let songUrl = await axios(
      `https://yt-backend-audio.herokuapp.com/download/?URL=${songId}`
    )
      .then((response) => response.data)
      .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", setError(error.message));
        }
      });
    if (songUrl !== undefined) {
      setPlayingSong([{ song: songUrl, title }]);
    }
  };
  const songOptions = (option) => {
    setSongs();
    setPlayingTitle();
    if (option === "Bollywood trending") {
      setSongs(newBollywoodSongs);
      setPlayingTitle(option);
    }
    if (option === "Bollywood 90s") {
      setSongs(oldBollywoodSongs);
      setPlayingTitle(option);
    }
    if (option === "Hollywood") {
      setSongs(hollywoodSongs);
      setPlayingTitle(option);
    }
  };

  return (
    <>
      <Router>
        <Header />
        <div className="w-full mx-auto mt-20 relative font-body h-auto">
          <div className="md:flex lg:w-3/4 mx-auto   w-full ">
            <Sidebar songOptions={songOptions} playingTitle={playingTitle} />

            <Switch>
              <Route path="/" exact>
                <Home
                  songs={songs}
                  playSong={playSong}
                  error={error}
                  playingTitle={playingTitle}
                  playingSong={playingSong}
                />
              </Route>
            </Switch>
          </div>
          <Player playingSong={playingSong} />
        </div>
        <Footer />
      </Router>
    </>
  );
}

export default App;
